const base_button = {
  gap: 4,
  display: 'flex',
  alignItems: 'center',
  borderRadius: 'var(--radius-lg)',
  boxShadow: 'none',
  ':hover': {
    boxShadow: '0px 2px 4px 0px #E4E4E7, 0px 5px 25px 0px rgba(228, 228, 231, 0.25)',
  },
  svg: {
    fill: 'currentColor',
  },
};

export const basic_action_button = {
  ...base_button,
  borderRadius: 'var(--radius-lg)',
  background: 'transparent',
  color: 'var(--color-greyscale-600)',
  fontSize: 14,
  fontWeight: '500',
  border: '1px solid var(--color-greyscale-200, #C8C9D0)',
  ':hover': {
    color: 'var(--color-greyscale-700)',
    background: 'var(--color-greyscale-100)',
    border: '1px solid var(--color-greyscale-200)',
  },
};

export const basic_action_button_disabled = {
  ...base_button,
  borderRadius: 'var(--radius-lg)',
  background: 'var(--color-greyscale-100)',
  color: 'var(--color-greyscale-100)',
  fontSize: 14,
  fontWeight: '500',
  border: '1px solid var(--color-greyscale-200, #C8C9D0)',
};

/**
 *  color: secondary
 *  variant: outlined
 */
export const secondary_action_button = {
  ...base_button,
  borderRadius: 'var(--radius-lg)',
  background: 'var(--color-secondary-50)',
  color: 'var(--color-secondary-600)',
  border: '1px solid var(--color-secondary-200)',
  ':hover': {
    color: 'var(--color-secondary-700)',
    background: 'var(--color-secondary-100)',
    border: '1px solid var(--color-secondary-300)',
  },
};

export const secondary_action_button_disabled = {
  ...base_button,
  border: 0,
  background: 'var(--color-greyscale-100)',
};
